const wowApp = require('angular').module('wowApp.shop');

wowApp.component('wowProductSaveToList', require('./product-save-to-list.component').productSaveToListComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/productsavetolist/index.js